module.exports = __webpack_public_path__ + "assets/img/modal-avatar-9f3322f4.png";